module.exports = __webpack_public_path__ + "static/media/no-photo.f98b32ce.png";